import React, { FC } from "react";
import ReactDOM from "react-dom";
import useContentful from "./hooks/useContentful";
import contentfulComponentLoop from "./lib/contentfulComponentLoop";

const Index: FC = () => {
  const contentfulDiv = document.getElementById('contentful');
  const entryId = contentfulDiv?.dataset?.entryId;
  if (!entryId) return null;

  const { contentfulData } = useContentful({ include: 10, 'sys.id': entryId });
  if (!contentfulData?.items) return null;

  return contentfulComponentLoop(contentfulData.items);
}

ReactDOM.render(<Index />, document.getElementById('collection-react'));